export default {"src":"/_next/static/media/overpass.0a4833e7.svg","height":256,"width":256};